<div class="container-fluid d-flex align-items-center h-100 justify-content-center">
  <!---resign
  ---->
  <div *ngIf="sessionStart">
    <div class="ml-3 mr-3 card rounded bg-lightgrey p-3 login-box">
    </div>
    <div [@inbgOutAnimation] class="rounded loading_overlay_login">
      <div class="loader-bg">
        <div class="loader"></div>
        <div class="loader-text">Preparing your things...</div>
      </div>
    </div>
  </div>
  <!---resign---->
  <div *ngIf="!sessionStart && showContent" [@inbgOutAnimation]
    class="ml-3 mr-3 card rounded bg-lightgrey p-3 test login-box">
    <div [@inbgOutAnimation] *ngIf="showSpinner" class="loading_overlay_login rounded">
      <div class="loader-bg">
        <div class="loader"></div>
        <div class="loader-text">Preparing your things...</div>
      </div>
    </div>
    <div class="row p-4">
      <img src="../../../assets/images/logo-clearramp-dark.png" class="pt-1 pb-1 pr-3 pl-3 w-100 center mx-auto">
    </div>
    <div class="row">
      <div *ngIf="errorMessage!=null" class="alert alert-danger">
        {{ errorMessage }}
      </div>
      <form class="mx-auto w-100 pl-4 pr-4">
        <p class="text-center">Please sign in</p>
        <div class="form-group">
          <label class="mb-0 f-13 font-weight-light" for="inputUsername">Username</label>
          <input type="text" id="inputUsername" (keyup.enter)="onEnter()" placeholder="Username" name="username"
            required autofocus class="form-control" [(ngModel)]="username" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-group mb-1">
          <label class="mb-0 f-13 font-weight-light" for="inputPassword">Password</label>
          <input type="{{showPassword ? 'text' : 'password'}}" id="inputPassword" placeholder="Password" name="password"
            required class="form-control" [(ngModel)]="password" [ngModelOptions]="{standalone: true}"
            (keyup.enter)="onEnter()">
          <a (click)="showPasswordToggle()" class="cursor-pointer ">
            <p class="text-center text-muted">{{showPassword ? 'Hide password' : 'Show password' }}</p>
          </a>
          <p class="mb-3 mt-3 f-12 text-center opacity-reverse cursor-pointer" [routerLink]="['/forgotten']">Forgot your
            Password?</p>
        </div>

        <div class="form-group">
          <button (click)="signIn()" type="button" id="signinbutton" class="btn button w-100">
            <span>{{buttonText}}</span>
          </button>
        </div>
        <a href="https://www.clearramp.com/pricing" style="border-radius: 0px; padding:0px;">
          <p class="font-weight-light opacity-reverse text-center cursor-pointer">Don't have an account? Sign Up</p>
        </a>
        <p class="mt-2 h-50px text-muted text-center op-05 center"> © ClearRamp - Eagleox Technologies ApS {{ year }}
        </p>
      </form>
    </div>
  </div>
</div>

<div *ngIf="includeStyles">
  <app-dynamicstyle></app-dynamicstyle>
</div>